import React, { Children, cloneElement, isValidElement } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { getIconLabel } from '../assets/icon-labels';
import './pop-up-infos.css';

export function actionText(node) {
  return Children.toArray(node)
    .map((child) => {
      if (typeof child === 'string' || typeof child === 'number') return String(child);
      if (!isValidElement(child) || child.props['aria-hidden'] || child.props.name || child.type?.iconName)
        return '';
      return actionText(child.props.children);
    })
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export default function PopUpInfos({ children, label, iconKey, side = 'top', sideOffset = 10 }) {
  const child = Children.only(children);
  const info =
    label ||
    child.props['aria-label'] ||
    child.props.title ||
    actionText(child.props.children) ||
    getIconLabel(iconKey);
  if (!info) return child;
  const trigger = cloneElement(child, { title: undefined });
  const disabled = Boolean(child.props.disabled);
  const needsWrapper = Object.hasOwn(child.props, 'disabled');
  return (
    <TooltipProvider delayDuration={250}>
      <Tooltip>
        <TooltipTrigger asChild>
          {needsWrapper ? (
            <span
              className="pop-up-infos-trigger"
              tabIndex={disabled ? 0 : undefined}
              aria-label={disabled ? info : undefined}
              onClick={(event) => {
                if (disabled) {
                  event.preventDefault();
                  event.stopPropagation();
                }
              }}
            >
              {trigger}
            </span>
          ) : (
            trigger
          )}
        </TooltipTrigger>
        <TooltipContent side={side} sideOffset={sideOffset} collisionPadding={12} className="pop-up-infos">
          {info}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
